module.exports = __webpack_public_path__ + "static/media/carousel-second-replace-card.f7ddcaec.png";